import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Table,
  Divider,
  Typography,
  Select,
  Checkbox,
  Switch,
  Steps,
  Spin,
} from 'antd';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import jira from '../jira/jira';
import IssueCard from './issueCardReport';

const { Text, Title } = Typography;
const { Option } = Select;

const ChartPreview = (props) => {
  const issueConfig = useSelector((state) => state.report.issueCardInfo);
  const triggerInformation = useSelector(
    (state) => state.report.triggerInformation
  );

  useEffect(() => {
    if (issueConfig) {
      setIssueCardConfig(issueConfig);
    }
  }, [issueConfig]);

  const [isLoading, setIsLoading] = useState(true);
  const [options, setOptions] = useState();

  const [issues, setIssues] = useState([]);
  const [issueCardConfig, setIssueCardConfig] = useState();

  //   useEffect(()=>{

  //     console.log('HighCharts report options', reportOptionsData)
  // if(reportOptionsData) setOptions(reportOptionsData)
  //   }, [reportOptionsData])
  // console.log('Chart Preview', issueCardConfig);

  useEffect(() => {
    if (props.allProjectData && props.allProjectData.issueArr) {
      setIssues(
        props.allProjectData && props.allProjectData.issueArr
          ? props.allProjectData.issueArr
          : []
      );
    } else {
      setIssues([]);
    }
  }, [props]);

  const getTotalIssuesCount = () => {
    let total = 0;
    if (props.dataSource && props.dataSource.length > 0) {
      props.dataSource.forEach((data) => {
        if (data && data.y) total += data.y;
      });
    }

    return total;
  };

  return (
    <>
      <div
        style={{
          // display: 'flex',
          // flexDirection: 'row',
          // justifyContent: 'space-between',
          padding: '16px 24px 16px 24px',
          // boxShadow: '2px 2px 5px 0px #eee',
          border: '1px solid #dedede',
          backgroundColor:
            localStorage.getItem('theme') == 'default' ? '#eee' : '#101010',
          borderRadius: 4,
        }}
      >
        <div style={{ display: 'flex' }}>
          <div
            style={{
              minWidth: '40px',
              backgroundColor: '#611f69',
              // fontWeight: 700,
              fontSize: '24',
              color: 'white',
              padding: 8,
              paddingRight: 10,
            }}
          >
            <img
              src={
                'https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg'
              }
              style={{ width: 30, height: 30, marginTop: 8 }}
              alt='slack'
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              backgroundColor:
                localStorage.getItem('theme') == 'default'
                  ? 'white'
                  : '#101010',
              padding: '16px 0px 16px 16px',
              width: '100%',
            }}
          >
            <div>
              <img
                src='https://app.troopr.io/logo/square.png'
                alt='logo'
                style={{
                  width: 24,
                  height: 24,
                  borderRadius: 5,
                  marginRight: 8,
                  marginTop: '3px',
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                fontSize: 11,
              }}
            >
              <div style={{ marginBottom: 0 }}>
                <Text strong style={{ marginRight: 4 }}>
                  Troopr Assistant
                </Text>
                <Text type='secondary'>
                  {triggerInformation && triggerInformation.timeOfDay
                    ? triggerInformation.timeOfDay
                    : '10:10'}
                </Text>
              </div>
              <div>
                <Text>
                  {props.slackmsg
                    ? props.slackmsg
                    : 'Report opening message here'}
                </Text>
              </div>
              <Divider style={{ margin: '8px 0px', width: '100%' }} />
              {props.type === 'chart' ? (
                <>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    {props.allowNext ? (
                      props.isLoadingActive ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            minHeight: 200,
                            minWidth: 300,
                          }}
                        >
                          <Spin
                            style={{
                              marginTop: 100,
                              //     marginRight: '50vw',
                            }}
                          />
                        </div>
                      ) : props.reportType && props.reportType == 'summary' ? (
                        props.reportOptions &&
                        props.reportOptions.series &&
                        props.reportOptions.series[0] ? (
                          <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                          >
                            <div
                              style={{
                                fontSize: 16,
                                display: 'flex',
                                flexWrap: 'wrap',
                                marginBottom: 16,
                              }}
                            >
                              {props.dataSource &&
                                props.dataSource.map((item) => (
                                  <div
                                    style={{ marginRight: 8 }}
                                    key={JSON.stringify(item)}
                                  >
                                    <Text italic>
                                      {item.name} : {item.y}
                                    </Text>
                                  </div>
                                ))}
                            </div>
                            {props.allProjectData &&
                              props.skill_type == 'app_message' && (
                                <>
                                  <Text>Total Issues :</Text>
                                  {/* {props.allProjectData.totalIssues} */}
                                  <Text strong>
                                    {(props.allProjectData &&
                                      props.allProjectData.totalIssues) ||
                                      getTotalIssuesCount()}
                                  </Text>
                                </>
                              )}

                            {props.skill_type == 'app_message' && (
                              <div
                                style={{
                                  padding: '4px 8px',
                                  border: '1px solid #ccc',
                                  background:
                                    localStorage.getItem('theme') == 'default'
                                      ? '#fff'
                                      : '#101010',
                                  borderRadius: 5,
                                  marginRight: 4,
                                  width: 'fit-content',
                                }}
                              >
                                Show Issues
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              minHeight: 200,
                              minWidth: 300,
                            }}
                          >
                            <Spin
                              style={
                                {
                                  //     marginRight: '50vw',
                                }
                              }
                            />
                          </div>
                        )
                      ) : props.reportOptions &&
                        props.reportOptions.series &&
                        props.reportOptions.series[0] &&
                        props.reportOptions.chart &&
                        props.reportOptions.chart.type &&
                        props.reportOptions.chart.type != '' ? (
                        <div
                          style={{
                            minWidth: 275,
                            width: '100%',
                            overflow: 'scroll',
                          }}
                        >
                          <HighchartsReact
                            highcharts={Highcharts}
                            options={
                              props.reportOptions
                              // options && options.options
                              // reportType == 'line' ? line_options : column_options
                            }
                            allowChartUpdate={true}
                            // loading={props.isLoadingActive}
                            // immutable={false}
                            updateArgs={[true, true, true]}
                          />
                          {props.allProjectData &&
                            props.skill_type == 'app_message' && (
                              <div style={{ marginTop: 16 }}>
                                <Text>Total Issues :</Text>
                                {/* <Text strong>
                                {props.allProjectData.totalIssues}
                              </Text> */}
                                <Text strong>
                                  {(props.allProjectData &&
                                    props.allProjectData.totalIssues) ||
                                    getTotalIssuesCount()}
                                </Text>

                                <div
                                  style={{
                                    padding: '2px 4px',
                                    border: '1px solid #ccc',
                                    background:
                                      localStorage.getItem('theme') == 'default'
                                        ? '#fff'
                                        : '#101010',
                                    borderRadius: 5,
                                    marginRight: 4,
                                    width: 'fit-content',
                                    marginTop: 6,
                                  }}
                                >
                                  Show Issues
                                </div>
                              </div>
                            )}
                        </div>
                      ) : props.noDataFound ? (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            // alignItems:'center',
                            minHeight: 200,
                            minWidth: 400,
                          }}
                        >
                          <Text>No Data Found</Text>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            minHeight: 200,
                            minWidth: 300,
                          }}
                        >
                          <Spin
                            style={
                              {
                                //     marginRight: '50vw',
                              }
                            }
                          />
                        </div>
                      )
                    ) : (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          minHeight: 200,
                          minWidth: 400,
                        }}
                      >
                        <Text>Fields are not selected</Text>
                      </div>
                    )}
                  </div>
                </>
              ) : props.type === 'list' ? (
                props.allowNext ? (
                  props.isLoadingActive ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        minHeight: 200,
                        minWidth: 300,
                      }}
                    >
                      <Spin
                        style={{
                          marginTop: 100,
                          //     marginRight: '50vw',
                        }}
                      />
                    </div>
                  ) : (
                    issueCardConfig && (
                      <IssueCard
                        viewType='channel'
                        {...issueCardConfig}
                        issueData={issues}
                      />
                    )
                  )
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      minHeight: 200,
                      minWidth: 400,
                    }}
                  >
                    <Text>Fields are not selected</Text>
                  </div>
                )
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChartPreview;
